export default () => {
    return (
        <div className="relative" id="book">
            <div className="mx-auto h-full max-w-7xl pt-16 pb-20 text-center lg:py-48 lg:text-left">
                <h2 className="mt-2 text-center text-5xl text-white font-custom italic font-bold uppercase mb-8">Inkijkexemplaar </h2>
                <iframe
                    className="object-cover w-[100%] h-[100vh] mx-auto"
                    src="/assets/inkijkexemplaar-succesvol-afvallen-zonder-voedingsschema.pdf#view=fitH"
                    loading="lazy"
                    allowFullScreen
                    width="100%"
                    height="100%"
                />
                <div className="text-center">
                    <a
                        href="/bestellen"
                        className="inline-flex uppercase mt-6 items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-black hover:text-white bg-we-are-yellow hover:bg-we-are-purple"
                    >
                        Bestellen
                    </a>
                </div>
            </div>
        </div>
    )
}